import { render, staticRenderFns } from "./Rankings_Select_Category.vue?vue&type=template&id=2799a7a7&scoped=true&"
import script from "./Rankings_Select_Category.vue?vue&type=script&lang=js&"
export * from "./Rankings_Select_Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799a7a7",
  null
  
)

export default component.exports